<div class="container-fluid py-5">
  <div class="row">
    <div class="col-md-12">
      <div class="card shadow-sm">
        <div class="card-body p-5">
          <h3 class="pt-0 pb-4">Work Group Administration</h3>
          <form [formGroup]="workGroupAdminForm">
            <div class="form-row">
              <div class="form-group col-md-4">
                <label aria-label="Agency" for="workgroup_agency">Agency</label>
                <select aria-label="Agency Dropdown" title="Agency Dropdown" id="workgroup_agency" formControlName="agency" class="w-100">
                  <option [ngValue]="null" selected disabled>Choose...</option>
                  @for (agency of agencyList; track agency) {
                    <option [ngValue]="agency">{{agency.agencyBureauName}} - {{agency.agencyCode}}</option>
                  }
                </select>
              </div>
              <div class="form-group col-md-4">
                <label aria-label="Bureau" for="workgroup_bureau">Bureau</label>
                <select aria-label="Bureau Dropdown" title="Bureau Dropdown" id="workgroup_bureau" formControlName="bureau" class="w-100">
                  <option [ngValue]="null" selected disabled>Choose...</option>
                  @for (bureau of bureauList; track bureau) {
                    <option [ngValue]="bureau">{{bureau.agencyBureauName}} - {{bureau.bureauCode}}</option>
                  }
                </select>
              </div>
              @if (workGroupsMap.size > 0) {
                <div class="form-group col-md-4">
                  <label aria-label="Work Group" for="workgroup_id">Work Group</label>
                  <select aria-label="Work Group Dropdown" title="Work Group Dropdown" id="workgroup_id" formControlName="workGroup" class="w-100">
                    <option [ngValue]="null" selected disabled>Choose...</option>
                    @for (key of keys; track key) {
                      <option [ngValue]="key">Work Group - {{key}}</option>
                    }
                  </select>
                </div>
              }
            </div>
            <hr>
              <div class="form-row">
                <div class="form-group col-md-5">
                  <label aria-label="Available Locations" for="available_locations">Available Locations
                    <span class="badge badge-primary">{{availableOrganizations?.length}}</span>
                  </label>
                  <select aria-label="Available Locations Selection" title="Available Locations Selection" id="available_locations" class="w-100" multiple
                    formControlName="availableLocations">
                    @for (organization of availableOrganizations; track organization) {
                      <option [ngValue]="organization">
                        {{organization.city}}, {{organization.stateName}}
                      </option>
                    }
                  </select>
                </div>
                <div class="form-group col-md-2 text-center pt-4">
                  <div class="p-2">
                    <button type="button" aria-label="Assign Location" class="btn btn-light w-auto" (click)="assignLocations()">
                      <i class="fa fa-chevron-right" aria-hidden="true"></i>
                    </button>
                  </div>
                  <div class="p-2">
                    <button type="button" aria-label="Unassign Location" class="btn btn-light w-auto" (click)="unassignLocations()">
                      <i class="fa fa-chevron-left" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
                <div class="form-group col-md-5">
                  <label aria-label="Assigned Location" for="assigned_locations">Assigned Locations
                    <span class="badge badge-primary">{{assignedOrganizations?.length}}</span>
                  </label>
                  <select aria-label="Assigned Locations Selection" title="Assigned Locations Selection" id="assigned_locations" class="w-100" multiple
                    formControlName="assignedLocations">
                    @for (organization of assignedOrganizations; track organization) {
                      <option [ngValue]="organization">
                        {{organization.city}}, {{organization.stateName}}
                      </option>
                    }
                  </select>
                </div>
              </div>

              <button type="button" class="btn btn-primary w-auto mt-4" (click)="update()">Update</button>
            </form>

          </div>
        </div>
      </div>
    </div>
  </div>
